/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'confluence-analytics-byline.abbreviated-user-views.message': '{count, plural, =0 {Vues} one {1} other {{count}}}',
  'confluence-analytics-byline.page-viewers.message': 'Utilisateurs disposant de droits en lecture',
  'confluence-analytics-byline.user-views.message':
    '{count, plural, =0 {Analyses} one {Vu par 1 personne} other {Vu par {count} personnes}}',
};
